import {useParams} from '@aboutyou/router';

export const useAdpLink = () => {
  const {brand, prefixedProductId} = useParams<{
    brand: string;
    prefixedProductId: string;
  }>();
  return '/p/' + brand + '/' + prefixedProductId;
};
